<ng-container *ngIf="exibir">
  <!-- pessoas e Começar: o mesmo bloco no cartão e no pé da folha "o que está incluído" -->
  <ng-template #acaoComecar>
    <div class="rodizio-acao">
      <div class="rodizio-campo">
        <small>Pessoas</small>
        <div class="rodizio-contador">
          <button type="button" (click)="mudePessoas(-1)" [disabled]="pessoas <= 1 || enviando" aria-label="Menos uma pessoa">−</button>
          <strong>{{pessoas}}</strong>
          <button type="button" (click)="mudePessoas(1)" [disabled]="pessoas >= 30 || enviando" aria-label="Mais uma pessoa">+</button>
        </div>
      </div>
      <button type="button" class="rodizio-btn rodizio-acao__btn" (click)="ative(planoEscolhido)" [disabled]="enviando || !planoEscolhido">
        <i class="fas fa-qrcode" aria-hidden="true" *ngIf="exigeCartao && !enviando"></i>
        {{enviando ? 'Começando…' : (exigeCartao ? 'Ler a comanda' : 'Começar')}}<small *ngIf="!enviando"> · {{totalDoPlano(planoEscolhido) | currency:'BRL'}}</small>
      </button>
    </div>
  </ng-template>
  <ng-template #chipsDePlano>
    <div class="rodizio-chips" *ngIf="planos.length > 1" role="radiogroup" aria-label="Plano">
      <button type="button" *ngFor="let plano of planos" class="rodizio-chip" [class.rodizio-chip--on]="plano === planoEscolhido"
              (click)="planoEscolhido = plano" role="radio" [attr.aria-checked]="plano === planoEscolhido">
        <b>{{plano.nome}}</b><small>{{plano.precoPorPessoa | currency:'BRL'}} /pessoa</small>
      </button>
    </div>
  </ng-template>

  <!-- antes de entrar: cartão de começar -->
  <div class="rodizio-cartao-comecar" *ngIf="!ativo">
    <div class="rodizio-cartao-comecar__cabeca">
      <span class="rodizio-cartao-comecar__icone"><i class="fas fa-sync-alt" aria-hidden="true"></i></span>
      <div class="rodizio-cartao-comecar__texto">
        <strong>{{planos.length === 1 ? planos[0].nome : 'Rodízio'}}</strong>
        <small *ngIf="!textoSituacao() && !motivoSemAcesso">{{planos.length === 1 ? 'Peça à vontade pelo celular. Paga no fim.' : 'Escolha o plano e quantas pessoas. Paga no fim.'}}</small>
        <small class="rodizio-cartao-comecar__alerta" *ngIf="textoSituacao() || motivoSemAcesso">{{textoSituacao() || motivoSemAcesso}}</small>
      </div>
      <div class="rodizio-cartao-comecar__preco" *ngIf="planos.length === 1">
        <b>{{planos[0].precoPorPessoa | currency:'BRL'}}</b> <small>por pessoa</small>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="chipsDePlano"></ng-container>
    <ng-container *ngTemplateOutlet="acaoComecar"></ng-container>
    <p class="rodizio-erro" *ngIf="erro && !folha" role="alert">{{erro}}</p>
    <p class="rodizio-cartao-comecar__ajuda" *ngIf="exigeCartao">Nesta casa o rodízio fica no cartão da comanda: leia o QR do cartão que o atendente entregou.</p>
    <div class="rodizio-cartao-comecar__pe">
      <button type="button" class="rodizio-link" (click)="abraFolha('planos')" *ngIf="planoEscolhido">O que está incluído</button>
      <button type="button" class="rodizio-link rodizio-link--fraco" (click)="abraFolha('codigo')">Tenho um código</button>
    </div>
  </div>

  <!-- com o código: topo do rodízio -->
  <div class="rodizio-topo" *ngIf="ativo && rodizio">
    <div class="rodizio-topo__texto">
      <strong>{{rodizio.plano?.nome}}</strong>
      <small><i class="rodizio-ponto"></i> Liberado · {{rodizio.plano?.pessoas}} {{rodizio.plano?.pessoas === 1 ? 'pessoa' : 'pessoas'}}</small>
    </div>
    <button type="button" class="rodizio-btn rodizio-btn--claro" (click)="abraFolha('rodada')" *ngIf="qtdeItensRodada"
            [attr.aria-label]="'Rodada com ' + qtdeItensRodada + ' itens'">
      <i class="fas fa-paper-plane" aria-hidden="true"></i> {{qtdeItensRodada}}
    </button>
    <button type="button" class="rodizio-btn rodizio-btn--claro" (click)="abraFolha('conta')">
      <i class="far fa-file-alt" aria-hidden="true"></i> Conta
    </button>
  </div>

  <!-- aviso e folhas vão para o body: dentro do cabeçalho fixo da loja ficariam sob a barra de categorias -->
  <div class="rodizio-camada" #camada>
  <div class="rodizio-aviso" *ngIf="aviso" role="status">
    <i class="fas fa-check" aria-hidden="true"></i>
    <div>{{aviso}}<small *ngIf="avisoDetalhe">{{avisoDetalhe}}</small></div>
  </div>

  <div class="rodizio-veu" *ngIf="folha" (click)="fecheFolha()"></div>

  <!-- código do rodízio -->
  <section class="rodizio-folha" *ngIf="folha === 'codigo'" role="dialog" aria-label="Entrar no rodízio">
    <button type="button" class="rodizio-fechar" (click)="fecheFolha()" aria-label="Fechar">&times;</button>
    <h3>Entrar no rodízio</h3>
    <p class="rodizio-sub">{{empresa?.identificadorMesa || 'Mesa'}} {{mesa?.nome}} · digite o código do rodízio</p>
    <div class="rodizio-codigo" [class.rodizio-codigo--erro]="erro">
      <input *ngFor="let digito of digitos; let i = index" [id]="'rodizio-digito-' + i" inputmode="numeric"
             autocomplete="one-time-code" maxlength="1" [value]="digito" [attr.aria-label]="'Dígito ' + (i + 1)"
             (input)="digitou(i, $event)" (keydown)="apagou(i, $event)" (paste)="colou($event)" [disabled]="enviando">
    </div>
    <p class="rodizio-erro" *ngIf="erro" role="alert">{{erro}}</p>
    <p class="rodizio-ajuda">
      <i class="far fa-file-alt" aria-hidden="true"></i>
      O código só é preciso quando a mesa tem mais de um rodízio. O atendente vê o código na comanda.
    </p>
    <button type="button" class="rodizio-btn rodizio-btn--cheio" (click)="entre()"
            [disabled]="enviando || digitos.join('').length !== 4">
      {{enviando ? 'Conferindo…' : 'Entrar'}}
    </button>
  </section>

  <!-- o que está incluído: só informa; pessoas e Começar ficam presos no pé -->
  <section class="rodizio-folha rodizio-folha--alta rodizio-folha--com-pe" *ngIf="folha === 'planos' && planoEscolhido" role="dialog" aria-label="O que está incluído">
    <button type="button" class="rodizio-fechar" (click)="fecheFolha()" aria-label="Fechar">&times;</button>
    <h3>{{planos.length === 1 ? planoEscolhido.nome : 'O que está incluído'}}</h3>
    <p class="rodizio-sub">{{planoEscolhido.precoPorPessoa | currency:'BRL'}} por pessoa · à vontade, pago no fim com o atendente</p>
    <ng-container *ngTemplateOutlet="chipsDePlano"></ng-container>
    <p class="rodizio-plano__descricao" *ngIf="planoEscolhido.descricao">{{planoEscolhido.descricao}}</p>
    <div class="rodizio-plano__categoria" *ngFor="let categoria of planoEscolhido.categorias">
      <h4>{{nomeDaSecao(planoEscolhido, categoria)}} <small *ngIf="categoria.maximoPorPessoa">· até {{categoria.maximoPorPessoa}} por pessoa</small></h4>
      <p>
        <ng-container *ngFor="let produto of produtosDaCategoria(categoria); let ultimo = last">{{produto.nome}}{{ultimo ? '' : ', '}}</ng-container>
      </p>
    </div>
    <div class="rodizio-pe">
      <p class="rodizio-erro" *ngIf="erro" role="alert">{{erro}}</p>
      <ng-container *ngTemplateOutlet="acaoComecar"></ng-container>
    </div>
  </section>

  <!-- rodada: incluído e à parte, cada item com − e +; o limite por pessoa é conferido antes de enviar -->
  <ng-template #linhaDaRodada let-item>
    <li>
      <div class="rodizio-itens__texto">
        <strong>{{item.produto?.nome}}</strong>
        <small *ngIf="item.observacao">{{item.observacao}}</small>
      </div>
      <span class="rodizio-itens__valor" *ngIf="item.total">{{item.total | currency:'BRL'}}</span>
      <span class="rodizio-qtde">
        <button type="button" (click)="mudeQtde(item, -1)" [attr.aria-label]="(item.qtde > 1 ? 'Menos um ' : 'Remover ') + item.produto?.nome">−</button>
        <strong>{{item.qtde}}</strong>
        <button type="button" (click)="mudeQtde(item, 1)" [attr.aria-label]="'Mais um ' + item.produto?.nome">+</button>
      </span>
    </li>
  </ng-template>
  <section class="rodizio-folha rodizio-folha--alta rodizio-folha--com-pe" *ngIf="folha === 'rodada'" role="dialog" aria-label="Rodada">
    <button type="button" class="rodizio-fechar" (click)="fecheFolha()" aria-label="Fechar">&times;</button>
    <h3>Rodada</h3>
    <p class="rodizio-sub">{{empresa?.identificadorMesa || 'Mesa'}} {{mesa?.nome}} · vai direto para a cozinha</p>
    <p class="rodizio-vazio" *ngIf="!itensDaRodada.length">Escolha no cardápio o que quer nesta rodada.</p>
    <ng-container *ngIf="itensIncluidos.length">
      <h5 class="rodizio-grupo">Incluído</h5>
      <ul class="rodizio-itens">
        <ng-container *ngFor="let item of itensIncluidos" [ngTemplateOutlet]="linhaDaRodada" [ngTemplateOutletContext]="{$implicit: item}"></ng-container>
      </ul>
    </ng-container>
    <p class="rodizio-limite" *ngIf="excessoDeLimite" role="alert"><i class="fas fa-exclamation-circle" aria-hidden="true"></i> {{excessoDeLimite}}</p>
    <ng-container *ngIf="itensAParte.length">
      <h5 class="rodizio-grupo">À parte</h5>
      <ul class="rodizio-itens">
        <ng-container *ngFor="let item of itensAParte" [ngTemplateOutlet]="linhaDaRodada" [ngTemplateOutletContext]="{$implicit: item}"></ng-container>
      </ul>
    </ng-container>
    <div class="rodizio-pe" *ngIf="itensDaRodada.length">
      <div class="rodizio-resumo">
        <span>Cobrado à parte nesta rodada</span>
        <strong>{{aParteDaRodada | currency:'BRL'}}</strong>
      </div>
      <p class="rodizio-erro" *ngIf="erro" role="alert">{{erro}}</p>
      <button type="button" class="rodizio-btn rodizio-btn--cheio" (click)="envieRodada()"
              [disabled]="enviando || !!excessoDeLimite">
        <i class="fas fa-paper-plane" aria-hidden="true"></i> {{enviando ? 'Enviando…' : 'Enviar para a cozinha'}}
      </button>
    </div>
  </section>

  <!-- conta -->
  <section class="rodizio-folha rodizio-folha--alta" *ngIf="folha === 'conta' && rodizio" role="dialog" aria-label="Minha conta">
    <button type="button" class="rodizio-fechar" (click)="fecheFolha()" aria-label="Fechar">&times;</button>
    <h3>{{empresa?.identificadorMesa || 'Mesa'}} {{rodizio.mesa?.nome || mesa?.nome}}</h3>
    <p class="rodizio-sub">{{rodizio.plano?.nome}}</p>

    <div class="rodizio-cartao">
      <h5>Rodadas</h5>
      <p class="rodizio-vazio" *ngIf="!rodizio.rodadas?.length">Nenhuma rodada ainda.</p>
      <div class="rodizio-rodada" *ngFor="let rodada of rodizio.rodadas">
        <div>
          <strong>Rodada {{rodada.codigo}} · {{rodada.horario | date:'HH:mm'}}</strong>
          <small>{{resumoDaRodada(rodada)}}<ng-container *ngIf="rodada.valorAParte"> · {{rodada.valorAParte | currency:'BRL'}} à parte</ng-container></small>
        </div>
        <span class="rodizio-status rodizio-status--{{rodada.status}}">{{rodada.situacao}}</span>
      </div>
    </div>

    <div class="rodizio-cartao">
      <h5>Valores</h5>
      <div class="rodizio-linha">
        <span>Rodízio · {{rodizio.plano?.pessoas}} {{rodizio.plano?.pessoas === 1 ? 'pessoa' : 'pessoas'}}</span>
        <strong>{{rodizio.plano?.total | currency:'BRL'}}</strong>
      </div>
      <div class="rodizio-linha">
        <span>Cobrado à parte</span>
        <strong>{{rodizio.aParte | currency:'BRL'}}</strong>
      </div>
      <div class="rodizio-linha" *ngIf="rodizio.taxaServico > 0">
        <span>Taxa de serviço</span>
        <strong>{{rodizio.taxaServico | currency:'BRL'}}</strong>
      </div>
      <div class="rodizio-linha" *ngIf="rodizio.desconto > 0">
        <span>Desconto</span>
        <strong>- {{rodizio.desconto | currency:'BRL'}}</strong>
      </div>
      <div class="rodizio-linha rodizio-linha--total">
        <span>Falta pagar</span>
        <strong>{{rodizio.faltaPagar | currency:'BRL'}}</strong>
      </div>
    </div>

    <p class="rodizio-erro" *ngIf="erro" role="alert">{{erro}}</p>
    <button type="button" class="rodizio-btn rodizio-btn--contorno" (click)="pecaParaEncerrar()"
            [disabled]="enviando || rodizio.encerramentoSolicitado">
      <i class="far fa-bell" aria-hidden="true"></i>
      {{rodizio.encerramentoSolicitado ? 'Atendente avisado: já vem fechar' : 'Pedir para encerrar'}}
    </button>
    <p class="rodizio-ajuda">O saldo é pago com o atendente.</p>
  </section>
  </div>
</ng-container>
